let svgLine = document.querySelectorAll('.line');

for(let i = 0; i < svgLine.length; i++){
  let line = svgLine[i];
  let length = line.getTotalLength();
  line.style.strokeDasharray = length;
  line.style.strokeDashoffset = length;
  line.classList.add('fait');
  var waypoint = new Waypoint({
    element: line,
    handler: function() {
      if(line.className = 'line fait'){
        line.style.animation = "dash 3s linear forwards";
        line.classList.remove('fait');
      }else{
        line.style.animation = "dash 3s linear forwards reverse";
        line.classList.add('fait');
      }
    },
    offset: '100%'
  });
}